// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"745":"0ed16d7a","893":"0ed16d7a"}[chunkId] + ".chunk.css";
};